// // // // // import React, { useEffect, useState } from "react";
// // // // // import { useParams } from "react-router-dom";
// // // // // import servicesData from "../data/services.json"; // JSON dosyasını içe aktar

// // // // // const ServiceDetail = () => {
// // // // //   const { district, slug } = useParams(); // URL’den ilçe ve hizmeti al
// // // // //   const [service, setService] = useState(null);

// // // // //   useEffect(() => {
// // // // //     if (servicesData[district]) {
// // // // //       const foundService = servicesData[district].services.find(item => item.slug === slug);
// // // // //       setService(foundService || null);
// // // // //     }
// // // // //   }, [district, slug]);

// // // // //   if (!service) {
// // // // //     return <h1 className="text-red-600 text-2xl">Hizmet bulunamadı!</h1>;
// // // // //   }

// // // // //   return (
// // // // //     <div className="max-w-screen-lg mx-auto py-10 px-6">
// // // // //       <h1 className="text-3xl font-bold text-[#003132] mb-6">{service.title}</h1>
// // // // //       <p className="text-gray-700 leading-relaxed">{service.description}</p>
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // export default ServiceDetail;
// // // // import React, { useEffect, useState } from "react";
// // // // import { useParams } from "react-router-dom";
// // // // import servicesData from "../data/services.json"; // JSON dosyasını içe aktar
// // // // import LeftSidebar from "./Sidebars/LeftSidebar";
// // // // import RightSidebar from "./Sidebars/RightSidebar";

// // // // const ServiceDetail = () => {
// // // //   const { district, slug } = useParams(); // URL’den ilçe ve hizmeti al
// // // //   const [service, setService] = useState(null);

// // // //   useEffect(() => {
// // // //     if (servicesData[district]) {
// // // //       const foundService = servicesData[district].services.find(item => item.slug === slug);
// // // //       setService(foundService || null);
// // // //     }
// // // //   }, [district, slug]);

// // // //   if (!service) {
// // // //     return <h1 className="text-red-600 text-2xl text-center mt-10">Hizmet bulunamadı!</h1>;
// // // //   }

// // // //   return (
// // // //     <> 
// // // //      <div className="max-w-7xl mx-auto py-6 px-4 grid grid-cols-1 lg:grid-cols-4 gap-8">
// // // //        <div className="order-2 lg:order-1 w-full">
// // // //           <LeftSidebar />
// // // //         </div>
// // // //     <div className="max-w-screen-lg mx-auto py-10 px-6 order-1 lg:order-2 lg:col-span-2">
// // // //       <h1 className="text-3xl font-bold text-[#003132] mb-6">{service.title}</h1>
// // // //       <p className="text-[17px] md:text-[18px] leading-8 text-gray-700 text-justify mb-6">
// // // //   {service.description}
// // // // </p>

// // // //       {/* Hizmet Özellikleri */}
// // // //       {service.features && (
// // // //         <div className="mt-6">
// // // //           <h2 className="text-xl font-semibold text-[#003132] mb-4">Hizmet Özellikleri</h2>
// // // //           <ul className="list-disc list-inside text-gray-700">
// // // //             {service.features.map((feature, index) => (
// // // //               <li key={index}>{feature}</li>
// // // //             ))}
// // // //           </ul>
// // // //         </div>
// // // //       )}

// // // //       {/* Halı Türleri */}
// // // //       {service.carpet_types && (
// // // //         <div className="mt-6">
// // // //           <h2 className="text-xl font-semibold text-[#003132] mb-4">Temizlenen Halı Türleri</h2>
// // // //           <ul className="list-disc list-inside text-gray-700">
// // // //             {service.carpet_types.map((type, index) => (
// // // //               <li key={index}>{type}</li>
// // // //             ))}
// // // //           </ul>
// // // //         </div>
// // // //       )}

// // // //       {/* Kurutma ve Paketleme */}
// // // //       {service.drying_packaging && (
// // // //         <div className="mt-6">
// // // //           <h2 className="text-xl font-semibold text-[#003132] mb-4">Kurutma ve Paketleme</h2>
// // // //           <p className="text-gray-700">{service.drying_packaging.description}</p>
// // // //         </div>
// // // //       )}

// // // //       {/* Çevre Dostu Temizlik */}
// // // //       {service.eco_friendly && (
// // // //         <div className="mt-6">
// // // //           <h2 className="text-xl font-semibold text-[#003132] mb-4">Çevre Dostu Temizlik</h2>
// // // //           <p className="text-gray-700">{service.eco_friendly.description}</p>
// // // //         </div>
// // // //       )}

// // // //       {/* Hizmet Alanı */}
// // // //       {service.service_area && (
// // // //         <div className="mt-6">
// // // //           <h2 className="text-xl font-semibold text-[#003132] mb-4">Hizmet Verdiğimiz Bölgeler</h2>
// // // //           <ul className="list-disc list-inside text-gray-700">
// // // //             {service.service_area.main.map((area, index) => (
// // // //               <li key={index}>{area}</li>
// // // //             ))}
// // // //           </ul>
// // // //           {service.service_area.nearby && (
// // // //             <>
// // // //               <h3 className="text-lg font-semibold text-[#005950] mt-4">Yakın Bölgeler</h3>
// // // //               <ul className="list-disc list-inside text-gray-700">
// // // //                 {service.service_area.nearby.map((area, index) => (
// // // //                   <li key={index}>{area}</li>
// // // //                 ))}
// // // //               </ul>
// // // //             </>
// // // //           )}
// // // //         </div>
// // // //       )}

// // // //       {/* İletişim Bilgileri */}
// // // //       {service.contact && (
// // // //         <div className="mt-6">
// // // //           <h2 className="text-xl font-semibold text-[#003132] mb-4">İletişim Bilgileri</h2>
// // // //           <p className="text-gray-700">📞 <strong>Telefon:</strong> {service.contact.phone}</p>
// // // //           <p className="text-gray-700">📧 <strong>E-Posta:</strong> {service.contact.email}</p>
// // // //         </div>
// // // //       )}
// // // //     </div>
    
    
     
// // // //       <div className="w-full order-3 lg:order-3">
// // // //           <RightSidebar />
// // // //         </div>

// // // //          </div>
// // // //       </>
     
// // // //   );
// // // // };

// // // // export default ServiceDetail;
// // // import React, { useEffect, useState } from "react";
// // // import { useParams } from "react-router-dom";
// // // import servicesData from "../data/services.json";
// // // import LeftSidebar from "./Sidebars/LeftSidebar";
// // // import RightSidebar from "./Sidebars/RightSidebar";

// // // const ServiceDetail = () => {
// // //   const { district, slug } = useParams();
// // //   const [service, setService] = useState(null);

// // //   useEffect(() => {
// // //     if (servicesData[district]) {
// // //       const foundService = servicesData[district].services.find(
// // //         (item) => item.slug === slug
// // //       );
// // //       setService(foundService || null);
// // //     }
// // //   }, [district, slug]);

// // //   if (!service) {
// // //     return (
// // //       <h1 className="text-red-600 text-2xl text-center mt-10">
// // //         Hizmet bulunamadı!
// // //       </h1>
// // //     );
// // //   }

// // //   const phoneRaw = service.contact?.phone || "+90 (501) 533 60 66";
// // //   const phoneClean = phoneRaw.replace(/\D/g, "");

// // //   return (
// // //     <div className="bg-[#f8fafc]">
// // //       <div className="max-w-7xl mx-auto py-8 px-4 grid grid-cols-1 lg:grid-cols-4 gap-8">
// // //         {/* SOL SIDEBAR */}
// // //         <div className="order-2 lg:order-1">
// // //           <LeftSidebar />
// // //         </div>

// // //         {/* ANA İÇERİK */}
// // //         <main className="order-1 lg:order-2 lg:col-span-2 space-y-8">
// // //           {/* HERO */}
// // //          {/* HERO */}
// // // <section className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#003132] via-[#004a47] to-[#006b5f] text-white p-6 md:p-10 shadow-xl">
// // //   <div className="absolute right-0 top-0 w-40 h-40 bg-white/10 rounded-full -mr-16 -mt-16" />

// // //   <div className="relative z-10">
// // //     {/* BUTONLAR TITLE ÜSTÜNDE */}
 

// // //     <h1 className="text-3xl md:text-5xl font-extrabold leading-tight mb-5 tracking-tight">
// // //       {service.title}
// // //     </h1>

// // //     <p className="text-white/90 text-[16px] md:text-[18px] leading-8 text-justify max-w-3xl font-medium">
// // //       {service.description}
// // //     </p>

// // //     <p className="text-sm text-white/80 mt-5 text-justify">
// // //       {service.title} fiyatları için hemen arayın veya WhatsApp’tan yazın.
// // //     </p>
// // //   </div>
// // //     <div className="max-w-md mx-auto mt-6 space-y-4">
// // //   <p className="text-center text-white/85 text-[15px] md:text-[16px] font-semibold leading-7">
// // //     Ücretsiz servis ve fiyat bilgisi için hemen arayın veya WhatsApp’tan yazın.
// // //   </p>

// // //   <a
// // //     href={`tel:+${phoneClean}`}
// // //     className="w-full flex items-center justify-center gap-3 bg-[#ef2929] hover:bg-[#d91f1f] text-white font-extrabold py-4 px-6 rounded-xl transition shadow-lg text-[17px] md:text-[18px]"
// // //   >
// // //     📞 +90 (501) 533 60 66
// // //   </a>

// // //   <a
// // //     href={`https://wa.me/${phoneClean}`}
// // //     target="_blank"
// // //     rel="noopener noreferrer"
// // //     className="w-full flex items-center justify-center gap-3 bg-[#22c55e] hover:bg-[#16a34a] text-white font-extrabold py-4 px-6 rounded-xl transition shadow-lg text-[17px] md:text-[18px]"
// // //   >
// // //     WhatsApp ile Yazın
// // //   </a>
// // // </div>
// // // </section>

// // //           {/* ÖZET KARTLAR */}
// // //           <section className="grid grid-cols-2 md:grid-cols-4 gap-4">
// // //             {[
// // //               ["4.9/5", "Müşteri Puanı"],
// // //               ["48 Saat", "Hızlı Teslim"],
// // //               ["Ücretsiz", "Alım Teslim"],
// // //               ["Hijyenik", "Temizlik"]
// // //             ].map((item, index) => (
// // //               <div
// // //                 key={index}
// // //                 className="bg-white rounded-2xl p-5 text-center shadow-sm border border-gray-100"
// // //               >
// // //                 <div className="text-2xl font-extrabold text-[#003132]">
// // //                   {item[0]}
// // //                 </div>
// // //                 <div className="text-sm text-gray-500 mt-1">{item[1]}</div>
// // //               </div>
// // //             ))}
// // //           </section>

// // //           {/* HİZMET ÖZELLİKLERİ */}
// // //           {service.features && (
// // //             <section className="bg-white rounded-3xl p-6 md:p-8 shadow-sm border border-gray-100">
// // //               <h2 className="text-2xl md:text-3xl font-extrabold text-[#003132] leading-tight mb-6">
// // //   {service.title} Özellikleri
// // // </h2>

// // //               <div className="grid gap-4">
// // //                 {service.features.map((feature, index) => (
// // //                   <div
// // //                     key={index}
// // //                     className="flex gap-3 bg-[#f8fafc] rounded-2xl p-4 border border-gray-100"
// // //                   >
// // //                     <span className="w-7 h-7 flex items-center justify-center rounded-full bg-green-100 text-green-700 font-bold shrink-0">
// // //                       ✓
// // //                     </span>
// // //                     <p className="text-[16px] leading-7 text-gray-700 text-justify">
// // //                       {feature}
// // //                     </p>
// // //                   </div>
// // //                 ))}
// // //               </div>
// // //             </section>
// // //           )}

// // //           {/* HALI TÜRLERİ */}
// // //           {service.carpet_types && (
// // //             <section className="bg-white rounded-3xl p-6 md:p-8 shadow-sm border border-gray-100">
// // //               <h2 className="text-2xl font-extrabold text-[#003132] mb-5">
// // //                 Temizlenen Halı Türleri
// // //               </h2>

// // //               <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
// // //                 {service.carpet_types.map((type, index) => (
// // //                   <div
// // //                     key={index}
// // //                     className="bg-[#f1f5f9] rounded-xl px-4 py-3 text-gray-700 font-medium"
// // //                   >
// // //                     {type}
// // //                   </div>
// // //                 ))}
// // //               </div>
// // //             </section>
// // //           )}

// // //           {/* KURUTMA / ÇEVRE */}
// // //           <section className="grid grid-cols-1 md:grid-cols-2 gap-5">
// // //             {service.drying_packaging && (
// // //               <div className="bg-white rounded-3xl p-6 shadow-sm border border-gray-100">
// // //                 <h2 className="text-xl font-extrabold text-[#003132] mb-3">
// // //                   Kurutma ve Paketleme
// // //                 </h2>
// // //                 <p className="text-[16px] leading-7 text-gray-700 text-justify">
// // //                   {service.drying_packaging.description}
// // //                 </p>
// // //               </div>
// // //             )}

// // //             {service.eco_friendly && (
// // //               <div className="bg-white rounded-3xl p-6 shadow-sm border border-gray-100">
// // //                 <h2 className="text-xl font-extrabold text-[#003132] mb-3">
// // //                   Çevre Dostu Temizlik
// // //                 </h2>
// // //                 <p className="text-[16px] leading-7 text-gray-700 text-justify">
// // //                   {service.eco_friendly.description}
// // //                 </p>
// // //               </div>
// // //             )}
// // //           </section>

// // //           {/* SÜREÇ */}
// // //           <section className="bg-white rounded-3xl p-6 md:p-8 shadow-sm border border-gray-100">
// // //             <h2 className="text-2xl font-extrabold text-[#003132] mb-6">
// // //               Hizmet Sürecimiz
// // //             </h2>

// // //             <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
// // //               {[
// // //                 ["1", "Bizi Arayın", `${service.title} için servis talebi oluşturun.`],
// // //                 ["2", "Ücretsiz Alım", "Ürünleriniz adresinizden teslim alınır."],
// // //                 ["3", "Profesyonel Temizlik", "Uygun yöntemlerle hijyenik temizlik yapılır."],
// // //                 ["4", "Teslimat", "Temiz ve paketli şekilde adresinize teslim edilir."]
// // //               ].map((step, index) => (
// // //                 <div
// // //                   key={index}
// // //                   className="bg-[#f8fafc] rounded-2xl p-4 border border-gray-100"
// // //                 >
// // //                   <div className="w-10 h-10 rounded-full bg-red-600 text-white flex items-center justify-center font-bold mb-3">
// // //                     {step[0]}
// // //                   </div>
// // //                   <h3 className="font-bold text-[#003132] mb-2">{step[1]}</h3>
// // //                   <p className="text-sm leading-6 text-gray-600">{step[2]}</p>
// // //                 </div>
// // //               ))}
// // //             </div>
// // //           </section>

// // //           {/* HİZMET ALANI */}
// // //           {service.service_area && (
// // //             <section className="bg-white rounded-3xl p-6 md:p-8 shadow-sm border border-gray-100">
// // //               <h2 className="text-2xl font-extrabold text-[#003132] mb-5">
// // //                 Hizmet Verdiğimiz Bölgeler
// // //               </h2>

// // //               <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
// // //                 {service.service_area.main.map((area, index) => (
// // //                   <div
// // //                     key={index}
// // //                     className="bg-[#f1f5f9] rounded-xl px-4 py-3 text-gray-700"
// // //                   >
// // //                     📍 {area}
// // //                   </div>
// // //                 ))}
// // //               </div>

// // //               {service.service_area.nearby && (
// // //                 <div className="mt-6">
// // //                   <h3 className="text-lg font-bold text-[#005950] mb-3">
// // //                     Yakın Bölgeler
// // //                   </h3>

// // //                   <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
// // //                     {service.service_area.nearby.map((area, index) => (
// // //                       <div
// // //                         key={index}
// // //                         className="bg-[#f8fafc] rounded-xl px-4 py-3 text-gray-700 border border-gray-100"
// // //                       >
// // //                         📍 {area}
// // //                       </div>
// // //                     ))}
// // //                   </div>
// // //                 </div>
// // //               )}
// // //             </section>
// // //           )}

// // //           {/* İLETİŞİM CTA */}
// // //           {service.contact && (
// // //             <section className="rounded-3xl bg-[#003132] text-white p-6 md:p-8 text-center shadow-xl">
// // //               <h2 className="text-2xl md:text-3xl font-extrabold mb-3">
// // //                 {service.title} İçin Hemen İletişime Geçin
// // //               </h2>

// // //               <p className="text-white/85 mb-5">
// // //                 Ücretsiz servis ve fiyat bilgisi için hemen arayın veya WhatsApp’tan yazın.
// // //               </p>

// // //               <div className="flex flex-col sm:flex-row gap-3 justify-center">
// // //                 <a
// // //                   href={`tel:+${phoneClean}`}
// // //                   className="bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-6 rounded-xl transition"
// // //                 >
// // //                   📞 {service.contact.phone}
// // //                 </a>

// // //                 <a
// // //                   href={`https://wa.me/${phoneClean}`}
// // //                   target="_blank"
// // //                   rel="noopener noreferrer"
// // //                   className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-xl transition"
// // //                 >
// // //                   WhatsApp ile Yazın
// // //                 </a>
// // //               </div>

// // //               {service.contact.email && (
// // //                 <p className="text-sm text-white/70 mt-4">
// // //                   📧 {service.contact.email}
// // //                 </p>
// // //               )}
// // //             </section>
// // //           )}
// // //         </main>

// // //         {/* SAĞ SIDEBAR */}
// // //         <div className="order-3 lg:order-3">
// // //           <RightSidebar />
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default ServiceDetail;

// // import React, { useEffect, useState } from "react";
// // import { useParams } from "react-router-dom";
// // import servicesData from "../data/services.json";
// // import LeftSidebar from "./Sidebars/LeftSidebar";
// // import RightSidebar from "./Sidebars/RightSidebar";
// // import carpetIcon from "../assets/icons/carpet.webp";

// // const ServiceDetail = () => {
// //   const { district, slug } = useParams();
// //   const [service, setService] = useState(null);

// //   useEffect(() => {
// //     if (servicesData[district]) {
// //       const foundService = servicesData[district].services.find(
// //         (item) => item.slug === slug
// //       );
// //       setService(foundService || null);
// //     }
// //   }, [district, slug]);

// //   if (!service) {
// //     return (
// //       <h1 className="text-red-600 text-2xl text-center mt-10">
// //         Hizmet bulunamadı!
// //       </h1>
// //     );
// //   }

// //   const phoneRaw = service.contact?.phone || "+90 (501) 533 60 66";
// //   const phoneClean = phoneRaw.replace(/\D/g, "");

// //   return (
// //     <div className="bg-[#f7faf9] font-sans">
// //       <div className="max-w-7xl mx-auto py-8 px-4 grid grid-cols-1 lg:grid-cols-4 gap-8">
// //         {/* SOL SIDEBAR */}
// //         <div className="order-2 lg:order-1">
// //           <LeftSidebar />
// //         </div>

// //         {/* ANA İÇERİK */}
// //         <main className="order-1 lg:order-2 lg:col-span-2 space-y-8">
// //           {/* HERO */}
// //           <section className="relative overflow-hidden rounded-[32px] bg-gradient-to-br from-[#002b2c] via-[#004846] to-[#007060] text-white p-6 md:p-10 shadow-[0_24px_70px_rgba(0,49,50,0.25)]">
// //             <div className="absolute -top-20 -right-20 w-56 h-56 rounded-full bg-white/10 blur-2xl" />
// //             <div className="absolute -bottom-24 -left-24 w-64 h-64 rounded-full bg-green-300/10 blur-3xl" />

// //             <div className="relative z-10">
// //               {/* BUTONLAR TITLE ÜSTÜNDE */}
// //               {/* <div className="grid grid-cols-2 gap-3 mb-6 max-w-xl">
// //                 <a
// //                   href={`tel:+${phoneClean}`}
// //                   className="flex items-center justify-center gap-2 bg-[#ef2929] hover:bg-[#d91f1f] text-white font-extrabold py-3 px-3 rounded-2xl transition shadow-[0_12px_30px_rgba(239,41,41,0.28)] text-sm md:text-base"
// //                 >
// //                   📞 Hemen Ara
// //                 </a>

// //                 <a
// //                   href={`https://wa.me/${phoneClean}`}
// //                   target="_blank"
// //                   rel="noopener noreferrer"
// //                   className="flex items-center justify-center gap-2 bg-[#22c55e] hover:bg-[#16a34a] text-white font-extrabold py-3 px-3 rounded-2xl transition shadow-[0_12px_30px_rgba(34,197,94,0.25)] text-sm md:text-base"
// //                 >
// //                   WhatsApp Teklif Al
// //                 </a>
// //               </div> */}
// //                   {/* <div className="max-w-md mx-auto space-y-4">
// //                 <a
// //                   href={`tel:+${phoneClean}`}
// //                   className="w-full flex items-center justify-center gap-3 bg-[#ef2929] hover:bg-[#d91f1f] text-white font-extrabold py-4 px-6 rounded-2xl transition shadow-lg text-[17px] md:text-[18px]"
// //                 >
// //                   📞 {service.contact.phone}
// //                 </a>

// //                 <a
// //                   href={`https://wa.me/${phoneClean}`}
// //                   target="_blank"
// //                   rel="noopener noreferrer"
// //                   className="w-full flex items-center justify-center gap-3 bg-[#22c55e] hover:bg-[#16a34a] text-white font-extrabold py-4 px-6 rounded-2xl transition shadow-lg text-[17px] md:text-[18px]"
// //                 >
// //                   WhatsApp ile Yazın
// //                 </a>
// //               </div> */}

// //               {/* <h1 className="text-3xl md:text-5xl font-extrabold leading-tight tracking-tight mb-5">
// //                 {service.title}
// //               </h1> */}
// //          <h1 className="text-[30px] md:text-[48px] font-semibold leading-tight tracking-[-0.3px]  mb-5 bg-gradient-to-r from-[#fef3c7] via-[#fde68a] to-[#facc15] bg-clip-text text-transparent">
// //   {service.title}
// // </h1>


// //               <p className="text-white/90 text-[16px] md:text-[18px] leading-8 text-justify max-w-3xl font-medium">
// //                 {service.description}
// //               </p>

// //               <p className="text-white/75 text-sm md:text-[15px] leading-7 mt-5 text-justify max-w-3xl">
// //                 Ücretsiz servis ve fiyat bilgisi için hemen arayın veya WhatsApp’tan yazın.
// //               </p>
// //                    <div className="max-w-md mx-auto space-y-4">
// //                 <a
// //                   href={`tel:+${phoneClean}`}
// //                   className="w-full flex items-center justify-center gap-3 bg-[#ef2929] hover:bg-[#d91f1f] text-white font-extrabold py-4 px-6 rounded-2xl transition shadow-lg text-[17px] md:text-[18px]"
// //                 >
// //                   📞 {service.contact.phone}
// //                 </a>

// //                 <a
// //                   href={`https://wa.me/${phoneClean}`}
// //                   target="_blank"
// //                   rel="noopener noreferrer"
// //                   className="w-full flex items-center justify-center gap-3 bg-[#22c55e] hover:bg-[#16a34a] text-white font-extrabold py-4 px-6 rounded-2xl transition shadow-lg text-[17px] md:text-[18px]"
// //                 >
// //                   WhatsApp ile Yazın
// //                 </a>
// //               </div>
// //             </div>
// //           </section>

// //           {/* ÖZET KARTLAR */}
// //           <section className="grid grid-cols-2 md:grid-cols-4 gap-4">
// //             {[
// //               ["4.9/5", "Müşteri Puanı"],
// //               ["48 Saat", "Hızlı Teslim"],
// //               ["Ücretsiz", "Alım Teslim"],
// //               ["Hijyenik", "Temizlik"]
// //             ].map((item, index) => (
// //               <div
// //                 key={index}
// //                 className="rounded-3xl bg-white/80 backdrop-blur-md p-5 text-center shadow-[0_12px_35px_rgba(0,49,50,0.06)] border border-white"
// //               >
// //                 <div className="text-2xl font-extrabold text-[#003132]">
// //                   {item[0]}
// //                 </div>
// //                 <div className="text-sm text-gray-500 mt-1 font-medium">
// //                   {item[1]}
// //                 </div>
// //               </div>
// //             ))}
// //           </section>

// //           {/* HİZMET ÖZELLİKLERİ */}
// //           {service.features && (
// //             <section className="rounded-[32px] p-5 md:p-8 bg-white shadow-[0_18px_55px_rgba(0,49,50,0.07)]">
// //               <div className="mb-7">
// //                 <p className="text-sm font-bold text-green-700 mb-2">
// //                   Hizmet Detayları
// //                 </p>
// //                   <h2 className="text-[20px] md:text-[48px] font-semibold leading-tight tracking-[-0.3px]  mb-5 bg-gradient-to-r from-[#2d302d] via-[#051609] to-[#02c902] bg-clip-text text-transparent">
// //   {service.title}
// // </h2>
// //               </div>

// //               <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
// //                 {service.features.map((feature, index) => {
// //                   const [title, ...descParts] = feature.split(":");
// //                   const description = descParts.join(":").trim();

// //                   return (
// //                     <div
// //                       key={index}
// //                       className="group relative min-h-[170px] rounded-[28px] p-6 bg-gradient-to-br from-white to-[#f4faf8] shadow-[0_14px_40px_rgba(0,49,50,0.06)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_22px_60px_rgba(0,49,50,0.11)]"
// //                     >
// //                       <div className="absolute top-5 right-5 w-9 h-9 bg-green-100 text-green-700 rounded-2xl flex items-center justify-center text-sm font-extrabold">
// //                         ✓
// //                       </div>

// //                       <div className="h-1 w-12 bg-green-500 rounded-full mb-4" />

// //                       <h3 className="text-[17px] md:text-[18px] font-extrabold text-[#003132] leading-6 pr-10 mb-3">
// //                         {title}
// //                       </h3>

// //                       {description ? (
// //                         <p className="text-[15px] md:text-[16px] text-gray-600 leading-7 text-justify">
// //                           {description}
// //                         </p>
// //                       ) : (
// //                         <p className="text-[15px] md:text-[16px] text-gray-600 leading-7 text-justify">
// //                           {feature}
// //                         </p>
// //                       )}
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             </section>
// //           )}

// //           {/* HALI TÜRLERİ */}
// //           {/* HALI TÜRLERİ */}
// // <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
// //   {service.carpet_types.map((type, index) => (
// //     <div
// //       key={index}
// //       className="group relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#f7fbf9] to-white p-5 shadow-[0_10px_30px_rgba(0,49,50,0.06)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_45px_rgba(0,49,50,0.12)]"
// //     >
// //       <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-green-100/70 transition group-hover:scale-125" />

// //       <div className="relative z-10 flex items-center gap-4">
// //         {/* HALI GÖRSELİ */}
// //         <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-white shadow-[0_8px_22px_rgba(0,49,50,0.12)] overflow-hidden">
// //           <img
// //             src={carpetIcon}
// //             alt="Halı Yıkama"
// //             className="h-12 w-12 object-cover rounded-xl"
// //           />
// //         </div>

// //         <div className="flex-1">
// //           <h3 className="text-[16px] md:text-[17px] font-extrabold text-[#003132] leading-6">
// //             {type}
// //           </h3>

// //           <p className="text-[13px] md:text-[14px] leading-6 text-gray-500 mt-2">
// //             Uygun deterjan, doğru fırçalama ve kontrollü kurutma.
// //           </p>
// //         </div>
// //       </div>
// //     </div>
// //   ))}
// // </div>

// //           {/* KURUTMA / ÇEVRE */}
// //           <section className="grid grid-cols-1 md:grid-cols-2 gap-5">
// //             {service.drying_packaging && (
// //               <div className="rounded-[32px] bg-white p-6 shadow-[0_18px_55px_rgba(0,49,50,0.07)]">
// //                 <h2 className="text-xl md:text-2xl font-extrabold text-[#003132] mb-4">
// //                   Kurutma ve Paketleme
// //                 </h2>
// //                 <p className="text-[16px] leading-7 text-gray-600 text-justify">
// //                   {service.drying_packaging.description}
// //                 </p>
// //               </div>
// //             )}

// //             {service.eco_friendly && (
// //               <div className="rounded-[32px] bg-white p-6 shadow-[0_18px_55px_rgba(0,49,50,0.07)]">
// //                 <h2 className="text-xl md:text-2xl font-extrabold text-[#003132] mb-4">
// //                   Çevre Dostu Temizlik
// //                 </h2>
// //                 <p className="text-[16px] leading-7 text-gray-600 text-justify">
// //                   {service.eco_friendly.description}
// //                 </p>
// //               </div>
// //             )}
// //           </section>

// //           {/* SÜREÇ */}
// //          {/* SÜREÇ */}
// // <section className="rounded-[32px] p-5 md:p-8 bg-white shadow-[0_18px_55px_rgba(0,49,50,0.07)]">
// //   <div className="mb-7">
// //     <span className="inline-flex items-center rounded-full bg-green-50 px-3 py-1 text-xs font-bold text-green-700 mb-3">
// //       Nasıl Çalışıyoruz?
// //     </span>

// //     <h2 className="text-[26px] md:text-3xl font-extrabold text-[#003132] leading-tight">
// //       Hizmet Sürecimiz
// //     </h2>

// //     <p className="text-[15px] leading-7 text-gray-500 mt-3 text-justify">
// //       Talebinizden teslimata kadar tüm süreç düzenli, hızlı ve kontrollü şekilde ilerler.
// //     </p>
// //   </div>

// //   <div className="relative space-y-4 pb-8">
// //   {[
// //     {
// //       no: "1",
// //       title: "Bizi Arayın",
// //       desc: `${service.title} için servis talebi oluşturun.`,
// //       color: "bg-emerald-100 text-emerald-700"
// //     },
// //     {
// //       no: "2",
// //       title: "Ücretsiz Alım",
// //       desc: "Ürünleriniz adresinizden ücretsiz olarak teslim alınır.",
// //       color: "bg-teal-100 text-teal-700"
// //     },
// //     {
// //       no: "3",
// //       title: "Profesyonel Temizlik",
// //       desc: "Uygun yöntemlerle hijyenik temizlik işlemi yapılır.",
// //       color: "bg-cyan-100 text-cyan-700"
// //     },
// //     {
// //       no: "4",
// //       title: "Teslimat",
// //       desc: "Temiz ve paketli şekilde adresinize teslim edilir.",
// //       color: "bg-lime-100 text-lime-700"
// //     }
// //   ].map((step, index) => (
// //     <div
// //       key={index}
// //       className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#f7fbf9] to-white p-5 pr-16 shadow-[0_10px_30px_rgba(0,49,50,0.06)]"
// //     >
// //       {/* sağ üst dekor + rakam */}
// //       <div
// //         className={`absolute -right-5 -top-5 h-20 w-20 rounded-bl-[36px] rounded-tr-3xl ${step.color}`}
// //       >
// //         <span className="absolute left-6 bottom-5 text-[18px] font-extrabold">
// //           {step.no}
// //         </span>
// //       </div>

// //       <div className="relative z-10">
// //         <h3 className="text-[18px] font-extrabold text-[#003132] mb-2 pr-6">
// //           {step.title}
// //         </h3>

// //         <p className="text-[14px] md:text-[15px] leading-7 text-gray-600 text-justify">
// //           {step.desc}
// //         </p>
// //       </div>
// //     </div>
// //   ))}
// // </div>
// // </section>

// //           {/* HİZMET ALANI */}
// //           {service.service_area && (
// //             <section className="rounded-[32px] p-5 md:p-8 bg-white shadow-[0_18px_55px_rgba(0,49,50,0.07)]">
// //               <h2 className="text-2xl md:text-3xl font-extrabold text-[#003132] mb-6">
// //                 Hizmet Verdiğimiz Bölgeler
// //               </h2>

// //               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
// //                 {service.service_area.main.map((area, index) => (
// //                   <div
// //                     key={index}
// //                     className="rounded-2xl bg-[#f4faf8] px-5 py-4 text-gray-700 font-medium shadow-sm"
// //                   >
// //                     📍 {area}
// //                   </div>
// //                 ))}
// //               </div>

// //               {service.service_area.nearby && (
// //                 <div className="mt-7">
// //                   <h3 className="text-lg font-extrabold text-[#005950] mb-4">
// //                     Yakın Bölgeler
// //                   </h3>

// //                   <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
// //                     {service.service_area.nearby.map((area, index) => (
// //                       <div
// //                         key={index}
// //                         className="rounded-2xl bg-[#f8fafc] px-5 py-4 text-gray-700 font-medium shadow-sm"
// //                       >
// //                         📍 {area}
// //                       </div>
// //                     ))}
// //                   </div>
// //                 </div>
// //               )}
// //             </section>
// //           )}

// //           {/* İLETİŞİM CTA */}
// //           {service.contact && (
// //             <section className="rounded-[32px] bg-[#003132] text-white p-6 md:p-8 text-center shadow-[0_24px_70px_rgba(0,49,50,0.22)]">
// //               <h2 className="text-2xl md:text-3xl font-extrabold mb-4 leading-tight">
// //                 {service.title} İçin Hemen İletişime Geçin
// //               </h2>

// //               <p className="text-white/85 mb-6 leading-7">
// //                 Ücretsiz servis ve fiyat bilgisi için hemen arayın veya WhatsApp’tan yazın.
// //               </p>

// //               <div className="max-w-md mx-auto space-y-4">
// //                 <a
// //                   href={`tel:+${phoneClean}`}
// //                   className="w-full flex items-center justify-center gap-3 bg-[#ef2929] hover:bg-[#d91f1f] text-white font-extrabold py-4 px-6 rounded-2xl transition shadow-lg text-[17px] md:text-[18px]"
// //                 >
// //                   📞 {service.contact.phone}
// //                 </a>

// //                 <a
// //                   href={`https://wa.me/${phoneClean}`}
// //                   target="_blank"
// //                   rel="noopener noreferrer"
// //                   className="w-full flex items-center justify-center gap-3 bg-[#22c55e] hover:bg-[#16a34a] text-white font-extrabold py-4 px-6 rounded-2xl transition shadow-lg text-[17px] md:text-[18px]"
// //                 >
// //                   WhatsApp ile Yazın
// //                 </a>
// //               </div>

// //               {service.contact.email && (
// //                 <p className="text-sm text-white/70 mt-5">
// //                   📧 {service.contact.email}
// //                 </p>
// //               )}
// //             </section>
// //           )}
// //         </main>

// //         {/* SAĞ SIDEBAR */}
// //         <div className="order-3 lg:order-3">
// //           <RightSidebar />
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default ServiceDetail;


// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import servicesData from "../data/services.json";
// import LeftSidebar from "./Sidebars/LeftSidebar";
// import RightSidebar from "./Sidebars/RightSidebar";
// import carpetIcon from "../assets/icons/carpet.webp";

// const ServiceDetail = () => {
//   const { district, slug } = useParams();
//   const [service, setService] = useState(null);

//   useEffect(() => {
//     if (servicesData[district]) {
//       const foundService = servicesData[district].services.find(
//         (item) => item.slug === slug
//       );
//       setService(foundService || null);
//     }
//   }, [district, slug]);

//   if (!service) {
//     return (
//       <h1 className="text-red-600 text-2xl text-center mt-10">
//         Hizmet bulunamadı!
//       </h1>
//     );
//   }

//   const phoneRaw = service.contact?.phone || "+90 (501) 533 60 66";
//   const phoneClean = phoneRaw.replace(/\D/g, "");

//   return (
//     <div className="bg-[#f4f0e6] font-sans">
//       <div className="max-w-7xl mx-auto py-8 px-4 grid grid-cols-1 lg:grid-cols-4 gap-8">
//         {/* SOL SIDEBAR */}
//         <div className="order-2 lg:order-1">
//           <LeftSidebar />
//         </div>

//         {/* ANA İÇERİK */}
//         <main className="order-1 lg:order-2 lg:col-span-2 space-y-8">
//           {/* HERO / ÜST İÇERİK */}
//           <section className="relative overflow-hidden rounded-[34px] bg-gradient-to-br from-[#022f2e] via-[#06443f] to-[#0b5a4d] text-white p-6 md:p-10 shadow-[0_28px_80px_rgba(0,49,50,0.32)] border border-[#d6a84f]/25">
//             <div className="absolute -top-24 -right-20 w-64 h-64 rounded-full bg-[#d6a84f]/15 blur-3xl" />
//             <div className="absolute -bottom-24 -left-20 w-72 h-72 rounded-full bg-black/20 blur-3xl" />

//             <div className="relative z-10">
//               <span className="inline-flex items-center rounded-full border border-[#d6a84f]/40 bg-[#d6a84f]/10 px-4 py-2 text-[12px] md:text-[13px] font-semibold tracking-wide text-[#f6d98b] mb-5">
//                 Profesyonel Temizlik Hizmetleri
//               </span>

//               <h1 className="font-serif text-[34px] md:text-[52px] font-semibold leading-tight tracking-[-0.6px] mb-5 bg-gradient-to-r from-[#fff1b8] via-[#f6d98b] to-[#d6a84f] bg-clip-text text-transparent">
//                 {service.title}
//               </h1>

//               <p className="text-[#f8f1dc]/90 text-[16px] md:text-[18px] leading-8 text-justify max-w-3xl font-medium">
//                 {service.description}
//               </p>

//               <p className="text-[#f8f1dc]/70 text-sm md:text-[15px] leading-7 mt-5 text-justify max-w-3xl">
//                 Ücretsiz servis, hijyenik temizlik ve güvenilir teslimat için
//                 hemen bizimle iletişime geçebilirsiniz.
//               </p>

//               <div className="max-w-md mx-auto space-y-4 mt-7">
//                 <a
//                   href={`tel:+${phoneClean}`}
//                   className="w-full flex items-center justify-center gap-3 bg-[#ef2929] hover:bg-[#d91f1f] text-white font-extrabold py-4 px-6 rounded-2xl transition shadow-[0_16px_35px_rgba(239,41,41,0.35)] text-[17px] md:text-[18px]"
//                 >
//                   📞 {service.contact?.phone || phoneRaw}
//                 </a>

//                 <a
//                   href={`https://wa.me/${phoneClean}`}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="w-full flex items-center justify-center gap-3 bg-[#22c55e] hover:bg-[#16a34a] text-white font-extrabold py-4 px-6 rounded-2xl transition shadow-[0_16px_35px_rgba(34,197,94,0.28)] text-[17px] md:text-[18px]"
//                 >
//                   WhatsApp ile Yazın
//                 </a>
//               </div>
//             </div>
//           </section>

//           {/* ÖZET KARTLAR */}
//           <section className="grid grid-cols-2 md:grid-cols-4 gap-4">
//             {[
//               ["4.9/5", "Müşteri Puanı"],
//               ["48 Saat", "Hızlı Teslim"],
//               ["Ücretsiz", "Alım Teslim"],
//               ["Hijyenik", "Temizlik"],
//             ].map((item, index) => (
//               <div
//                 key={index}
//                 className="relative overflow-hidden rounded-[28px] bg-gradient-to-br from-[#022f2e] via-[#06443f] to-[#0b5a4d] p-5 text-center shadow-[0_18px_45px_rgba(0,49,50,0.25)] border border-[#d6a84f]/30"
//               >
//                 <div className="absolute -top-10 -right-10 h-24 w-24 rounded-full bg-[#d6a84f]/10 blur-xl" />

//                 <div className="relative z-10 font-serif text-[24px] md:text-[28px] font-semibold text-[#f6d98b] leading-tight">
//                   {item[0]}
//                 </div>

//                 <div className="relative z-10 mt-2 text-[13px] md:text-[14px] font-semibold tracking-wide text-[#f5ead2]/90">
//                   {item[1]}
//                 </div>
//               </div>
//             ))}
//           </section>

//           {/* HİZMET ÖZELLİKLERİ */}
//           {service.features && (
//             <section className="rounded-[34px] p-5 md:p-8 bg-white/90 shadow-[0_20px_60px_rgba(0,49,50,0.10)] border border-[#d6a84f]/20">
//               <div className="mb-7">
//                 <p className="text-sm font-bold text-[#b8923f] mb-2 tracking-wide">
//                   Hizmet Detayları
//                 </p>

//                 <h2 className="font-serif text-[28px] md:text-[44px] font-semibold leading-tight tracking-[-0.4px] mb-5 bg-gradient-to-r from-[#022f2e] via-[#06443f] to-[#b8923f] bg-clip-text text-transparent">
//                   {service.title}
//                 </h2>
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                 {service.features.map((feature, index) => {
//                   const [title, ...descParts] = feature.split(":");
//                   const description = descParts.join(":").trim();

//                   return (
//                     <div
//                       key={index}
//                       className="group relative min-h-[170px] rounded-[28px] p-6 bg-gradient-to-br from-[#ffffff] to-[#f7f1e4] border border-[#d6a84f]/25 shadow-[0_14px_40px_rgba(0,49,50,0.07)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_65px_rgba(0,49,50,0.14)]"
//                     >
//                       <div className="absolute top-5 right-5 w-10 h-10 bg-[#d6a84f]/15 text-[#b8923f] rounded-2xl flex items-center justify-center text-sm font-extrabold">
//                         ✓
//                       </div>

//                       <div className="h-[3px] w-14 bg-gradient-to-r from-[#d6a84f] to-[#f6d98b] rounded-full mb-4" />

//                       <h3 className="font-serif text-[18px] md:text-[20px] font-semibold text-[#022f2e] leading-6 pr-10 mb-3">
//                         {title}
//                       </h3>

//                       <p className="text-[15px] md:text-[16px] text-gray-600 leading-7 text-justify">
//                         {description || feature}
//                       </p>
//                     </div>
//                   );
//                 })}
//               </div>
//             </section>
//           )}

//           {/* HALI TÜRLERİ */}
//           {service.carpet_types && (
//             <section className="rounded-[34px] p-5 md:p-8 bg-white/90 shadow-[0_20px_60px_rgba(0,49,50,0.10)] border border-[#d6a84f]/20">
//               <div className="mb-7">
//                 <p className="text-sm font-bold text-[#b8923f] mb-2 tracking-wide">
//                   Temizlenen Ürünler
//                 </p>

//                 <h2 className="font-serif text-[28px] md:text-[40px] font-semibold text-[#022f2e] leading-tight">
//                   Halı Türleri
//                 </h2>
//               </div>

//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                 {service.carpet_types.map((type, index) => (
//                   <div
//                     key={index}
//                     className="group relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#ffffff] to-[#f7f1e4] p-5 border border-[#d6a84f]/25 shadow-[0_12px_35px_rgba(0,49,50,0.07)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_22px_60px_rgba(0,49,50,0.14)]"
//                   >
//                     <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-[#d6a84f]/12 transition group-hover:scale-125 blur-xl" />

//                     <div className="relative z-10 flex items-center gap-4">
//                       <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-white shadow-[0_8px_22px_rgba(0,49,50,0.12)] overflow-hidden border border-[#d6a84f]/20">
//                         <img
//                           src={carpetIcon}
//                           alt="Halı Yıkama"
//                           className="h-12 w-12 object-cover rounded-xl"
//                         />
//                       </div>

//                       <div className="flex-1">
//                         <h3 className="font-serif text-[17px] md:text-[19px] font-semibold text-[#022f2e] leading-6">
//                           {type}
//                         </h3>

//                         <p className="text-[13px] md:text-[14px] leading-6 text-gray-500 mt-2">
//                           Uygun deterjan, doğru fırçalama ve kontrollü kurutma.
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </section>
//           )}

//           {/* KURUTMA / ÇEVRE */}
//           <section className="grid grid-cols-1 md:grid-cols-2 gap-5">
//             {service.drying_packaging && (
//               <div className="relative overflow-hidden rounded-[32px] bg-gradient-to-br from-[#022f2e] via-[#06443f] to-[#0b5a4d] p-6 shadow-[0_20px_60px_rgba(0,49,50,0.22)] border border-[#d6a84f]/25">
//                 <div className="absolute -top-10 -right-10 h-28 w-28 rounded-full bg-[#d6a84f]/10 blur-xl" />

//                 <h2 className="relative z-10 font-serif text-2xl md:text-3xl font-semibold text-[#f6d98b] mb-4">
//                   Kurutma ve Paketleme
//                 </h2>

//                 <p className="relative z-10 text-[16px] leading-7 text-[#f8f1dc]/85 text-justify">
//                   {service.drying_packaging.description}
//                 </p>
//               </div>
//             )}

//             {service.eco_friendly && (
//               <div className="relative overflow-hidden rounded-[32px] bg-gradient-to-br from-[#ffffff] to-[#f7f1e4] p-6 shadow-[0_20px_60px_rgba(0,49,50,0.09)] border border-[#d6a84f]/25">
//                 <div className="absolute -top-10 -right-10 h-28 w-28 rounded-full bg-[#d6a84f]/15 blur-xl" />

//                 <h2 className="relative z-10 font-serif text-2xl md:text-3xl font-semibold text-[#022f2e] mb-4">
//                   Çevre Dostu Temizlik
//                 </h2>

//                 <p className="relative z-10 text-[16px] leading-7 text-gray-600 text-justify">
//                   {service.eco_friendly.description}
//                 </p>
//               </div>
//             )}
//           </section>

//           {/* SÜREÇ */}
//           <section className="rounded-[34px] p-5 md:p-8 bg-white/90 shadow-[0_20px_60px_rgba(0,49,50,0.10)] border border-[#d6a84f]/20">
//             <div className="mb-7">
//               <span className="inline-flex items-center rounded-full border border-[#d6a84f]/30 bg-[#d6a84f]/10 px-4 py-2 text-xs font-bold text-[#b8923f] mb-3">
//                 Nasıl Çalışıyoruz?
//               </span>

//               <h2 className="font-serif text-[28px] md:text-[40px] font-semibold text-[#022f2e] leading-tight">
//                 Hizmet Sürecimiz
//               </h2>

//               <p className="text-[15px] leading-7 text-gray-500 mt-3 text-justify">
//                 Talebinizden teslimata kadar tüm süreç düzenli, hızlı ve
//                 kontrollü şekilde ilerler.
//               </p>
//             </div>

//             <div className="relative space-y-4 pb-2">
//               {[
//                 {
//                   no: "1",
//                   title: "Bizi Arayın",
//                   desc: `${service.title} için servis talebi oluşturun.`,
//                 },
//                 {
//                   no: "2",
//                   title: "Ücretsiz Alım",
//                   desc: "Ürünleriniz adresinizden ücretsiz olarak teslim alınır.",
//                 },
//                 {
//                   no: "3",
//                   title: "Profesyonel Temizlik",
//                   desc: "Uygun yöntemlerle hijyenik temizlik işlemi yapılır.",
//                 },
//                 {
//                   no: "4",
//                   title: "Teslimat",
//                   desc: "Temiz ve paketli şekilde adresinize teslim edilir.",
//                 },
//               ].map((step, index) => (
//                 <div
//                   key={index}
//                   className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#022f2e] via-[#06443f] to-[#0b5a4d] p-5 pr-16 shadow-[0_16px_45px_rgba(0,49,50,0.20)] border border-[#d6a84f]/25"
//                 >
//                   <div className="absolute right-0 top-0 h-20 w-20 rounded-bl-[36px] rounded-tr-3xl bg-[#d6a84f] text-[#022f2e]">
//                     <span className="absolute left-6 bottom-5 text-[20px] font-extrabold">
//                       {step.no}
//                     </span>
//                   </div>

//                   <div className="relative z-10">
//                     <h3 className="font-serif text-[20px] font-semibold text-[#f6d98b] mb-2 pr-6">
//                       {step.title}
//                     </h3>

//                     <p className="text-[14px] md:text-[15px] leading-7 text-[#f8f1dc]/85 text-justify">
//                       {step.desc}
//                     </p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </section>

//           {/* HİZMET ALANI */}
//           {service.service_area && (
//             <section className="rounded-[34px] p-5 md:p-8 bg-white/90 shadow-[0_20px_60px_rgba(0,49,50,0.10)] border border-[#d6a84f]/20">
//               <h2 className="font-serif text-[28px] md:text-[40px] font-semibold text-[#022f2e] mb-6">
//                 Hizmet Verdiğimiz Bölgeler
//               </h2>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 {service.service_area.main.map((area, index) => (
//                   <div
//                     key={index}
//                     className="rounded-2xl bg-gradient-to-br from-[#ffffff] to-[#f7f1e4] px-5 py-4 text-[#022f2e] font-semibold shadow-sm border border-[#d6a84f]/20"
//                   >
//                     📍 {area}
//                   </div>
//                 ))}
//               </div>

//               {service.service_area.nearby && (
//                 <div className="mt-7">
//                   <h3 className="font-serif text-xl font-semibold text-[#b8923f] mb-4">
//                     Yakın Bölgeler
//                   </h3>

//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                     {service.service_area.nearby.map((area, index) => (
//                       <div
//                         key={index}
//                         className="rounded-2xl bg-gradient-to-br from-[#022f2e] to-[#0b5a4d] px-5 py-4 text-[#f8f1dc] font-semibold shadow-sm border border-[#d6a84f]/20"
//                       >
//                         📍 {area}
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </section>
//           )}

//           {/* İLETİŞİM CTA */}
//           {service.contact && (
//             <section className="relative overflow-hidden rounded-[34px] bg-gradient-to-br from-[#022f2e] via-[#06443f] to-[#0b5a4d] text-white p-6 md:p-8 text-center shadow-[0_30px_85px_rgba(0,49,50,0.32)] border border-[#d6a84f]/25">
//               <div className="absolute -top-16 -right-16 h-40 w-40 rounded-full bg-[#d6a84f]/15 blur-2xl" />
//               <div className="absolute -bottom-16 -left-16 h-44 w-44 rounded-full bg-black/20 blur-2xl" />

//               <div className="relative z-10">
//                 <h2 className="font-serif text-2xl md:text-4xl font-semibold mb-4 leading-tight text-[#f6d98b]">
//                   {service.title} İçin Hemen İletişime Geçin
//                 </h2>

//                 <p className="text-[#f8f1dc]/85 mb-6 leading-7">
//                   Ücretsiz servis ve fiyat bilgisi için hemen arayın veya
//                   WhatsApp’tan yazın.
//                 </p>

//                 <div className="max-w-md mx-auto space-y-4">
//                   <a
//                     href={`tel:+${phoneClean}`}
//                     className="w-full flex items-center justify-center gap-3 bg-[#ef2929] hover:bg-[#d91f1f] text-white font-extrabold py-4 px-6 rounded-2xl transition shadow-lg text-[17px] md:text-[18px]"
//                   >
//                     📞 {service.contact.phone}
//                   </a>

//                   <a
//                     href={`https://wa.me/${phoneClean}`}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="w-full flex items-center justify-center gap-3 bg-[#22c55e] hover:bg-[#16a34a] text-white font-extrabold py-4 px-6 rounded-2xl transition shadow-lg text-[17px] md:text-[18px]"
//                   >
//                     WhatsApp ile Yazın
//                   </a>
//                 </div>

//                 {service.contact.email && (
//                   <p className="text-sm text-[#f8f1dc]/70 mt-5">
//                     📧 {service.contact.email}
//                   </p>
//                 )}
//               </div>
//             </section>
//           )}
//         </main>

//         {/* SAĞ SIDEBAR */}
//         <div className="order-3 lg:order-3">
//           <RightSidebar />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ServiceDetail;

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import servicesData from "../data/services.json";
import LeftSidebar from "./Sidebars/LeftSidebar";
import RightSidebar from "./Sidebars/RightSidebar";
import carpetIcon from "../assets/icons/carpet.webp";

const ServiceDetail = () => {
  const { district, slug } = useParams();
  const [service, setService] = useState(null);

  useEffect(() => {
    if (servicesData[district]) {
      const foundService = servicesData[district].services.find(
        (item) => item.slug === slug
      );
      setService(foundService || null);
    }
  }, [district, slug]);

  if (!service) {
    return (
      <h1 className="text-red-600 text-2xl text-center mt-10">
        Hizmet bulunamadı!
      </h1>
    );
  }

  const phoneRaw = service.contact?.phone || "+90 (501) 533 60 66";
  const phoneClean = phoneRaw.replace(/\D/g, "");

  return (
    <div className="bg-[#f4efe6] font-sans">
      <div className="max-w-7xl mx-auto py-8 px-4 grid grid-cols-1 lg:grid-cols-4 gap-8">
        <div className="order-2 lg:order-1">
          <LeftSidebar />
        </div>

        <main className="order-1 lg:order-2 lg:col-span-2 space-y-8">
          {/* ÜST İÇERİK */}
          <section className="relative overflow-hidden rounded-[34px] bg-[#f6efe4] border border-[#c49a5a]/35 p-6 md:p-10 shadow-[0_18px_55px_rgba(55,28,22,0.14)]">
            <div className="absolute -top-20 -right-20 h-60 w-60 rounded-full bg-[#7a1f2b]/10 blur-3xl" />
            <div className="absolute -bottom-20 -left-20 h-60 w-60 rounded-full bg-[#063047]/10 blur-3xl" />

            <div className="relative z-10">
              <span className="inline-flex items-center rounded-full border border-[#c49a5a]/45 bg-[#fff8eb] px-4 py-2 text-[12px] font-semibold tracking-wide text-[#9a6a2f] mb-5">
                Profesyonel Temizlik Hizmetleri
              </span>

              <h1 className="font-serif text-[34px] md:text-[52px] font-semibold leading-tight tracking-[-0.6px] mb-5 text-[#111111]">
                {service.title}
              </h1>

              <div className="h-[2px] w-24 rounded-full bg-gradient-to-r from-[#9a6a2f] via-[#d8b26a] to-[#9a6a2f] mb-5" />

              <p className="text-[#3b2f2a] text-[16px] md:text-[18px] leading-8 text-justify max-w-3xl font-medium">
                {service.description}
              </p>

              <p className="text-[#6f6258] text-sm md:text-[15px] leading-7 mt-5 text-justify max-w-3xl">
                Ücretsiz servis, güvenilir teslimat ve profesyonel temizlik için
                hemen arayın ya da WhatsApp üzerinden teklif alın.
              </p>

              <div className="max-w-md mx-auto space-y-4 mt-7">
                <a
                  href={`tel:+${phoneClean}`}
                  className="w-full flex items-center justify-center gap-3 bg-[#7a1f2b] hover:bg-[#641722] text-[#fff8eb] font-extrabold py-4 px-6 rounded-2xl transition shadow-[0_14px_32px_rgba(122,31,43,0.28)] text-[17px] md:text-[18px]"
                >
                  📞 {service.contact?.phone || phoneRaw}
                </a>

                <a
                  href={`https://wa.me/${phoneClean}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full flex items-center justify-center gap-3 bg-[#97f302] hover:bg-[#042436] text-[#020202] font-extrabold py-4 px-6 rounded-2xl transition shadow-[0_14px_32px_rgba(6,48,71,0.25)] text-[17px] md:text-[18px]"
                >
                  WhatsApp ile Yazın
                </a>
              </div>
            </div>
          </section>

          {/* ÖZET KARTLAR */}
          <section className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              ["4.9/5", "Müşteri Puanı"],
              ["72 Saat", "Hızlı Teslim"],
              ["Ücretsiz", "Alım Teslim"],
              ["Hijyenik", "Temizlik"],
            ].map((item, index) => (
              <div
                key={index}
                className="relative overflow-hidden rounded-[28px] bg-[#f6efe4] border border-[#c49a5a]/35 p-5 text-center shadow-[0_16px_45px_rgba(55,28,22,0.13)]"
              >
                <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-[#7a1f2b]/10 blur-xl" />
                <div className="mx-auto mb-3 h-[2px] w-14 rounded-full bg-gradient-to-r from-[#9a6a2f] via-[#d8b26a] to-[#9a6a2f]" />

                <div className="font-serif text-[26px] md:text-[30px] font-semibold text-[#111111]">
                  {item[0]}
                </div>

                <div className="mt-2 text-[13px] md:text-[14px] font-semibold tracking-wide text-[#7a1f2b]">
                  {item[1]}
                </div>
              </div>
            ))}
          </section>

          {/* HİZMET ÖZELLİKLERİ */}
          {service.features && (
            <section className="rounded-[34px] p-5 md:p-8 bg-[#f6efe4] shadow-[0_18px_55px_rgba(55,28,22,0.13)] border border-[#c49a5a]/35">
              <div className="mb-7">
                <p className="text-sm font-bold text-[#9a6a2f] mb-2 tracking-wide">
                  Hizmet Detayları
                </p>

                <h2 className="font-serif text-[28px] md:text-[44px] font-semibold leading-tight tracking-[-0.4px] mb-5 text-[#111111]">
                  {service.title}
                </h2>

                <div className="h-[2px] w-24 rounded-full bg-gradient-to-r from-[#9a6a2f] via-[#d8b26a] to-[#9a6a2f]" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                {service.features.map((feature, index) => {
                  const [title, ...descParts] = feature.split(":");
                  const description = descParts.join(":").trim();

                  return (
                    <div
                      key={index}
                      className="group relative min-h-[170px] rounded-[28px] p-6 bg-[#fff8eb] border border-[#c49a5a]/30 shadow-[0_12px_34px_rgba(55,28,22,0.10)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_22px_55px_rgba(55,28,22,0.16)]"
                    >
                      <div className="absolute top-5 right-5 w-10 h-10 bg-[#f1dfbd] text-[#9a6a2f] rounded-2xl flex items-center justify-center text-sm font-extrabold">
                        ✓
                      </div>

                      <div className="h-[3px] w-14 bg-gradient-to-r from-[#9a6a2f] via-[#d8b26a] to-[#9a6a2f] rounded-full mb-4" />

                      <h3 className="font-serif text-[18px] md:text-[20px] font-semibold text-[#111111] leading-6 pr-10 mb-3">
                        {title}
                      </h3>

                      <p className="text-[15px] md:text-[16px] text-[#4a3c35] leading-7 text-justify">
                        {description || feature}
                      </p>
                    </div>
                  );
                })}
              </div>
            </section>
          )}

          {/* HALI TÜRLERİ */}
          {service.carpet_types && (
            <section className="rounded-[34px] p-5 md:p-8 bg-[#f6efe4] shadow-[0_18px_55px_rgba(55,28,22,0.13)] border border-[#c49a5a]/35">
              <div className="mb-7">
                <p className="text-sm font-bold text-[#9a6a2f] mb-2 tracking-wide">
                  Temizlenen Ürünler
                </p>

                <h2 className="font-serif text-[28px] md:text-[40px] font-semibold text-[#111111] leading-tight">
                  Halı Türleri
                </h2>

                <div className="mt-4 h-[2px] w-24 rounded-full bg-gradient-to-r from-[#9a6a2f] via-[#d8b26a] to-[#9a6a2f]" />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {service.carpet_types.map((type, index) => (
                  <div
                    key={index}
                    className="group relative overflow-hidden rounded-3xl bg-[#fff8eb] p-5 border border-[#c49a5a]/30 shadow-[0_12px_35px_rgba(55,28,22,0.10)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_22px_55px_rgba(55,28,22,0.16)]"
                  >
                    <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-[#063047]/10 blur-xl" />

                    <div className="relative z-10 flex items-center gap-4">
                      <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-[#f6efe4] shadow-[0_8px_22px_rgba(55,28,22,0.14)] overflow-hidden border border-[#c49a5a]/30">
                        <img
                          src={carpetIcon}
                          alt="Halı Yıkama"
                          className="h-12 w-12 object-cover rounded-xl"
                        />
                      </div>

                      <div className="flex-1">
                        <h3 className="font-serif text-[17px] md:text-[19px] font-semibold text-[#111111] leading-6">
                          {type}
                        </h3>

                        <p className="text-[13px] md:text-[14px] leading-6 text-[#6f6258] mt-2">
                          Uygun deterjan, doğru fırçalama ve kontrollü kurutma.
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          )}

          {/* KURUTMA / ÇEVRE */}
          <section className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {service.drying_packaging && (
              <div className="relative overflow-hidden rounded-[32px] bg-[#f6efe4] p-6 shadow-[0_18px_45px_rgba(55,28,22,0.13)] border border-[#c49a5a]/35">
                <div className="absolute -top-10 -right-10 h-28 w-28 rounded-full bg-[#7a1f2b]/10 blur-xl" />

                <h2 className="relative z-10 font-serif text-2xl md:text-3xl font-semibold text-[#111111] mb-4">
                  Kurutma ve Paketleme
                </h2>

                <div className="relative z-10 h-[2px] w-20 rounded-full bg-gradient-to-r from-[#9a6a2f] via-[#d8b26a] to-[#9a6a2f] mb-4" />

                <p className="relative z-10 text-[16px] leading-7 text-[#4a3c35] text-justify">
                  {service.drying_packaging.description}
                </p>
              </div>
            )}

            {service.eco_friendly && (
              <div className="relative overflow-hidden rounded-[32px] bg-[#fff8eb] p-6 shadow-[0_18px_45px_rgba(55,28,22,0.13)] border border-[#c49a5a]/35">
                <div className="absolute -top-10 -right-10 h-28 w-28 rounded-full bg-[#063047]/10 blur-xl" />

                <h2 className="relative z-10 font-serif text-2xl md:text-3xl font-semibold text-[#111111] mb-4">
                  Çevre Dostu Temizlik
                </h2>

                <div className="relative z-10 h-[2px] w-20 rounded-full bg-gradient-to-r from-[#9a6a2f] via-[#d8b26a] to-[#9a6a2f] mb-4" />

                <p className="relative z-10 text-[16px] leading-7 text-[#4a3c35] text-justify">
                  {service.eco_friendly.description}
                </p>
              </div>
            )}
          </section>

          {/* SÜREÇ */}
          <section className="rounded-[34px] p-5 md:p-8 bg-[#f6efe4] shadow-[0_18px_55px_rgba(55,28,22,0.13)] border border-[#c49a5a]/35">
            <div className="mb-7">
              <span className="inline-flex items-center rounded-full border border-[#c49a5a]/45 bg-[#fff8eb] px-4 py-2 text-xs font-bold text-[#9a6a2f] mb-3">
                Nasıl Çalışıyoruz?
              </span>

              <h2 className="font-serif text-[28px] md:text-[40px] font-semibold text-[#111111] leading-tight">
                Hizmet Sürecimiz
              </h2>

              <div className="mt-4 h-[2px] w-24 rounded-full bg-gradient-to-r from-[#9a6a2f] via-[#d8b26a] to-[#9a6a2f]" />

              <p className="text-[15px] leading-7 text-[#6f6258] mt-4 text-justify">
                Talebinizden teslimata kadar tüm süreç düzenli, hızlı ve
                kontrollü şekilde ilerler.
              </p>
            </div>

            <div className="relative space-y-4 pb-2">
              {[
                {
                  no: "1",
                  title: "Bizi Arayın",
                  desc: `${service.title} için servis talebi oluşturun.`,
                },
                {
                  no: "2",
                  title: "Ücretsiz Alım",
                  desc: "Ürünleriniz adresinizden ücretsiz olarak teslim alınır.",
                },
                {
                  no: "3",
                  title: "Profesyonel Temizlik",
                  desc: "Uygun yöntemlerle hijyenik temizlik işlemi yapılır.",
                },
                {
                  no: "4",
                  title: "Teslimat",
                  desc: "Temiz ve paketli şekilde adresinize teslim edilir.",
                },
              ].map((step, index) => (
                <div
                  key={index}
                  className="relative overflow-hidden rounded-3xl bg-[#fff8eb] p-5 pr-16 shadow-[0_12px_35px_rgba(55,28,22,0.11)] border border-[#c49a5a]/30"
                >
                  <div className="absolute right-0 top-0 h-12 w-12 rounded-bl-[26px] rounded-tr-2xl bg-[#111111] text-[#d8b26a]">
                    <span className="absolute left-4 bottom-3 text-[20px] font-serif font-semibold">
                      {step.no}
                    </span>
                  </div>

                  <div className="relative z-10">
                    <h3 className="font-serif text-[20px] font-semibold text-[#111111] mb-2 pr-6">
                      {step.title}
                    </h3>

                    <p className="text-[14px] md:text-[15px] leading-7 text-[#4a3c35] text-justify">
                      {step.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* HİZMET ALANI */}
          {service.service_area && (
            <section className="rounded-[34px] p-5 md:p-8 bg-[#f6efe4] shadow-[0_18px_55px_rgba(55,28,22,0.13)] border border-[#c49a5a]/35">
              <h2 className="font-serif text-[28px] md:text-[40px] font-semibold text-[#111111] mb-4">
                Hizmet Verdiğimiz Bölgeler
              </h2>

              <div className="h-[2px] w-24 rounded-full bg-gradient-to-r from-[#9a6a2f] via-[#d8b26a] to-[#9a6a2f] mb-6" />

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {service.service_area.main.map((area, index) => (
                  <div
                    key={index}
                    className="rounded-2xl bg-[#fff8eb] px-5 py-4 text-[#111111] font-semibold shadow-sm border border-[#c49a5a]/30"
                  >
                    📍 {area}
                  </div>
                ))}
              </div>

              {service.service_area.nearby && (
                <div className="mt-7">
                  <h3 className="font-serif text-xl font-semibold text-[#7a1f2b] mb-4">
                    Yakın Bölgeler
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {service.service_area.nearby.map((area, index) => (
                      <div
                        key={index}
                        className="rounded-2xl bg-[#fff8eb] px-5 py-4 text-[#4a3c35] font-semibold shadow-sm border border-[#c49a5a]/30"
                      >
                        📍 {area}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </section>
          )}

          {/* İLETİŞİM CTA */}
          {service.contact && (
            <section className="relative overflow-hidden rounded-[34px] bg-[#111111] text-white p-6 md:p-8 text-center shadow-[0_26px_70px_rgba(0,0,0,0.25)] border border-[#c49a5a]/35">
              <div className="absolute -top-16 -right-16 h-40 w-40 rounded-full bg-[#7a1f2b]/30 blur-2xl" />
              <div className="absolute -bottom-16 -left-16 h-44 w-44 rounded-full bg-[#063047]/35 blur-2xl" />

              <div className="relative z-10">
                <h2 className="font-serif text-2xl md:text-4xl font-semibold mb-4 leading-tight text-[#f6d98b]">
                  {service.title} İçin Hemen İletişime Geçin
                </h2>

                <p className="text-[#f6efe4]/85 mb-6 leading-7">
                  Ücretsiz servis ve fiyat bilgisi için hemen arayın veya
                  WhatsApp’tan yazın.
                </p>

                <div className="max-w-md mx-auto space-y-4">
                  <a
                    href={`tel:+${phoneClean}`}
                    className="w-full flex items-center justify-center gap-3 bg-[#7a1f2b] hover:bg-[#641722] text-white font-extrabold py-4 px-6 rounded-2xl transition shadow-lg text-[17px] md:text-[18px]"
                  >
                    📞 {service.contact.phone}
                  </a>

                  <a
                    href={`https://wa.me/${phoneClean}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full flex items-center justify-center gap-3 bg-[#063047] hover:bg-[#042436] text-white font-extrabold py-4 px-6 rounded-2xl transition shadow-lg text-[17px] md:text-[18px]"
                  >
                    WhatsApp ile Yazın
                  </a>
                </div>

                {service.contact.email && (
                  <p className="text-sm text-[#f6efe4]/70 mt-5">
                    📧 {service.contact.email}
                  </p>
                )}
              </div>
            </section>
          )}
        </main>

        <div className="order-3 lg:order-3">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default ServiceDetail;